/**
 * Toggle search group visibility
 */

const toggleSearchGroup = () => {
  const toggleButton = document.querySelector('#search-icon');
  const searchGroup = document.querySelector('.search-group');
  const searchInput = document.querySelector('.search-click');
  toggleButton.addEventListener('click', () => {
    searchGroup.classList.toggle('active');
    searchInput.focus();
  });
};
export default toggleSearchGroup;
